import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../../config/theme';
import Campaign from '../../components/Campaign';
import { useParams } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import CampaignSkeleton from '../../components/CampaignSkeleton';
import SvgIcon from '@material-ui/core/SvgIcon';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SelectionBox from './SelectionBox';
import { numberAsCurrency, minPurchasableTickets, initialTicketSelection } from '../../utils/index';
import ShortWinner from './ShortWinner';
import Swal from 'sweetalert2';
import Cookie from 'js-cookie';
import moment from 'moment';
import InstantWinners from './InstantWinners';
import SubcampaignsSection from './SubcampaignsSection';
import RoundUpPurchaseModal from '../../components/RoundUpPurchaseModal';
import { trackEvent } from '../../utils';

const useStyles = makeStyles((theme) => ({
  main: {},
  mainHeader: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  lightningIcon: {
    top: '7px',
    position: 'relative',
    filter: 'brightness(0) saturate(100%) invert(16%) sepia(97%) saturate(2586%) hue-rotate(222deg) brightness(89%) contrast(101%)',
  },
  title: {
    fontWeight: 700,
    color: '#1A1A1A',
    '& small': {
      fontWeight: 400,
      color: '#666666',
      fontSize: '70%',
      marginLeft: '10px'
    }
  },
  myTicketsTop: {
    textDecoration: 'none',
    fontSize: '0.875rem',
    fontWeight: 700,
    color: '#2D6E2F',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 20px',
    backgroundColor: '#E9F6E9',
    borderRadius: '12px',
    boxSizing: 'border-box',
  },
  myTicketsIcon: {
    fontSize: 20,
    color: '#2D6E2F',
    fill: '#2D6E2F',
    flexShrink: 0,
    '& path': {
      fill: '#2D6E2F',
    },
  },
  myTicketsLabel: {
    display: 'inline-block',
    textDecoration: 'none',
    lineHeight: 1.25,
  },
  priceTag: {
    fontWeight: 400,
    color: '#666666',
    fontSize: '130%',
    float: 'none',
    textAlign: 'center',
    textTransform: 'uppercase',
    marginTop: '8px',
    marginBottom: '8px',
    backgroundColor: '#EDF8EE',
    borderRadius: '10px',
    '& span': {
      fontWeight: 700,
      color: '#2D6E2F',
    },
  },
  social: {
    marginTop: '4px',
    textAlign: 'left',
    color: '#666666',
    fontSize: '0.78rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    border: '1px solid #E8EDF5',
    borderRadius: '8px',
    padding: '8px 10px',
    '& span': {
      color: '#1A1A1A',
      fontWeight: 600,
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  description: {
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E7F0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    padding: '20px',
    color: '#1A1A1A',
    textAlign: 'left',
    overflow: 'hidden',
  },
  descriptionHeader: {
    width: '100%',
    border: 0,
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: 0,
    color: '#1A1A1A',
    fontSize: '1rem',
    fontWeight: 700,
    marginBottom: '10px',
    textAlign: 'left',
  },
  descriptionArrow: {
    transition: 'transform 0.2s ease',
  },
  descriptionArrowOpen: {
    transform: 'rotate(180deg)',
  },
  descriptionContent: {
    overflowY: 'scroll',
    maxHeight: '300px',
  },
  descriptionContentClosed: {
    display: 'none',
  },
  regulationLink: {
    display: 'inline-block',
    marginBottom: '12px',
    marginRight: '16px',
    color: '#316832',
    fontWeight: 700,
    textDecoration: 'underline',
  },
  instantBox: {
    marginTop: '20px',
    padding: '10px 20px',
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    borderRadius: '12px',
    border: '1px solid #29562A',
    backgroundColor: '#316832',
    position: 'relative',
    color: 'white',
    '& img': {
      position: 'absolute',
      bottom: '3px',
      right: '4px',
      [theme.breakpoints.down('md')]: {
        width: '130px'
      }
    }
  },
  instantDescription: {
    fontWeight: 600,
    fontSize: '130%',
    textAlign: 'left',
    margin: '25px 150px 20px 20px',
    [theme.breakpoints.down('md')]: {
      fontSize: '90%',
      margin: '10px 90px 10px 10px'
    }
  },
  instantHelper: {
    fontWeight: 400,
    fontSize: '100%',
    textAlign: 'left',
    margin: '10px 150px 10px 20px',
    [theme.breakpoints.down('md')]: {
      fontSize: '80%',
      margin: '5px 110px 5px 10px'
    }
  },
  sectionSpacing: {
    marginTop: '10px',
  },
  salesBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: '#D4EDDA',
    color: '#000',
    borderRadius: '20px',
    padding: '2px 10px',
    fontSize: '0.72rem',
    fontWeight: 600,
    '& img': {
      width: '12px',
      height: '12px',
      filter: 'brightness(0) saturate(100%)',
    },
  },
}));

export default function CampaignDetails({ currentUser, campaign = null, influencer }) {
  const classes = useStyles();
  const history = useHistory();
  let { campaignId } = useParams();
  const [loading, setLoading] = React.useState(campaign == null);
  const [purchaseLoading, setPurchaseLoading] = React.useState(false);
  const [currentCampaign, setCurrentCampaign] = React.useState(campaign);
  const [selectedTickets, setSelectedTickets] = React.useState(startTickets());
  const [roundUpModal, setRoundUpModal] = React.useState({
    open: false,
    currentTickets: 0,
    suggestedTickets: 0,
    suggestedTotalFormatted: '',
  });
  const [descriptionOpen, setDescriptionOpen] = React.useState(false);
  const [autoPurchaseTriggered, setAutoPurchaseTriggered] = React.useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const ticketParameter = urlParams.get('tickets') ? parseInt(urlParams.get('tickets')) : null;
  
  function safeSetSelectedTickets(value) {
    if (value >= minTickets() && value <= maxTickets()) {
      setSelectedTickets(value);
    }
  }

  function maxTickets() {
    return currentCampaign?.max_amount == 0 ? 1000000 : currentCampaign?.max_amount;
  }

  function minTickets() {
    return minPurchasableTickets(currentCampaign);
  }

  function startTickets() {
    return ticketParameter ? parseInt(ticketParameter) : minTickets();
  }

  function submitPurchaseOrder(ticketsAmount) {
    setPurchaseLoading(true);
    Swal.fire({
      title: 'Efetuando a compra',
      didOpen: () => {
        Swal.showLoading();
      },
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    axios
      .post('/api/v1/purchase_orders', {
        purchase_order: {
          campaign_id: currentCampaign.id,
          tickets_amount: ticketsAmount,
        },
      })
      .then((response) => {
        trackEvent(
          'InitiateCheckout',
          {
            value: parseFloat(response.data.total_value),
            currency: 'BRL',
            ...(response.data.affiliate_name && { affiliate_name: response.data.affiliate_name })
          },
          { dedupe: false }
        );
        Swal.close();
        history.push(`/${influencer.username}/site/compras/${response.data.id}`);
      })
      .catch((error) => {
        var errorMessages;
        try {
          errorMessages = Object.values(error.response.data).join('<br/>');
        } catch (e) {
          errorMessages = 'Erro desconhecido';
        }
        Swal.fire({
          title: 'Erro ao efetuar a compra',
          html: errorMessages,
          icon: 'error',
        });
      })
      .finally(() => {
        setPurchaseLoading(false);
      });
  }

  function purchaseCallback() {
    if (currentUser == null) {
      Cookie.set('redirect_to', `/${influencer.username}/site/campanhas/${currentCampaign.id}?tickets=${selectedTickets}`, { path: '/', expires: 1 });
      window.location.href = '/public/sign_in';
      return;
    }
    const currentTickets = Number(selectedTickets) || 0;
    const suggestedTickets = (Math.floor(currentTickets / 5) + 1) * 5;
    const maxCap = maxTickets();
    if (suggestedTickets > maxCap) {
      submitPurchaseOrder(currentTickets);
      return;
    }
    const suggestedTotalFormatted = numberAsCurrency(suggestedTickets * currentCampaign.ticket_price);
    setRoundUpModal({
      open: true,
      currentTickets,
      suggestedTickets,
      suggestedTotalFormatted,
    });
  }

  function handleRoundUpAccept() {
    const amount = roundUpModal.suggestedTickets;
    setRoundUpModal((s) => ({ ...s, open: false }));
    submitPurchaseOrder(amount);
  }

  // Fechou o modal sem escolher: desistiu da compra, nenhum pedido é criado.
  function handleRoundUpClose() {
    setRoundUpModal((s) => ({ ...s, open: false }));
  }

  function handleRoundUpDecline() {
    const amount = roundUpModal.currentTickets;
    setRoundUpModal((s) => ({ ...s, open: false }));
    submitPurchaseOrder(amount);
  }

  function fetchCampaign() {
    const pageParams = new URLSearchParams(window.location.search);
    const affiliateToken = pageParams.get('a');
    const specialOffer = pageParams.get('oferta');
    const offerToken = pageParams.get('oferta_minima');
    const queryParams = new URLSearchParams();
    if (affiliateToken) queryParams.set('a', affiliateToken);
    if (specialOffer) queryParams.set('oferta', specialOffer);
    if (offerToken) queryParams.set('oferta_minima', offerToken);
    ['utm_campaign', 'utm_source', 'utm_content'].forEach((key) => {
      const value = pageParams.get(key);
      if (value) queryParams.set(key, value);
    });
    const query = queryParams.toString();
    const url = query
      ? `/api/v1/campaigns/${campaignId}.json?${query}`
      : `/api/v1/campaigns/${campaignId}.json`;
    axios.get(url)
      .then((response) => {
        setSelectedTickets(ticketParameter || initialTicketSelection(response.data));
        setCurrentCampaign(response.data);
      })
      .catch((error) => {
        setCurrentCampaign(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function instantPrizeHelperText(campaign) {
    if (campaign.instant_prize_tickets > campaign.instant_winners.length) {
      return `Ainda faltam ${campaign.instant_prize_tickets - campaign.instant_winners.length} bilhetes premiados, compre agora!`
    } else {
      return `Confira os sortudos que levaram os bilhetes premiados abaixo!`
    }
  }

  React.useEffect(() => {
    if (campaign == null) {
      fetchCampaign();
    }
  }, []);

  React.useEffect(() => {
    if (!ticketParameter || !currentUser || !currentCampaign || autoPurchaseTriggered) return;
    setAutoPurchaseTriggered(true);
    history.replace(window.location.pathname);
    purchaseCallback();
  }, [currentUser, currentCampaign, ticketParameter, autoPurchaseTriggered]);

  React.useEffect(() => {
    if (!currentCampaign) return;

    const ticketPrice = parseFloat(currentCampaign.ticket_price);
    trackEvent(
      'ViewContent',
      {
        value: ticketPrice,
        currency: 'BRL',
        content_name: currentCampaign.title,
        content_ids: [String(currentCampaign.id)],
        content_type: 'product',
        contents: [{
          id: String(currentCampaign.id),
          name: currentCampaign.title,
          quantity: 1,
          price: ticketPrice
        }],
        ...(currentCampaign.affiliate_name && { affiliate_name: currentCampaign.affiliate_name })
      },
      { dedupe: false }
    );
  }, [currentCampaign?.id]);

  return (
    <ThemeProvider theme={theme}>
      <RoundUpPurchaseModal
        open={roundUpModal.open}
        onClose={handleRoundUpClose}
        onAccept={handleRoundUpAccept}
        onDecline={handleRoundUpDecline}
        currentTickets={roundUpModal.currentTickets}
        suggestedTickets={roundUpModal.suggestedTickets}
        suggestedTotalFormatted={roundUpModal.suggestedTotalFormatted}
      />
      <ResponsiveContainer>
        <div className={classes.main}>
          <div className={classes.mainHeader}>
            <Typography variant="h5" className={classes.title}>
              <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/lightning.svg" className={classes.lightningIcon} />&nbsp;Campanhas
            </Typography>
            <Link to={`/${influencer.username}/site/compras`} className={classes.myTicketsTop}>
              <SvgIcon className={classes.myTicketsIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"></path>
              </SvgIcon>
              <span className={classes.myTicketsLabel}>Meus títulos</span>
            </Link>
          </div>
          {loading &&
            <CampaignSkeleton mode='first' />
          }
          <div className={classes.campaigns}>
            {!loading && currentCampaign && (
              <>
                <Campaign campaign={currentCampaign} currentUser={currentUser} mode='first' link={false} showHeroButton={false} showHeroPrice={false} onBoostExpire={fetchCampaign} />
                <div>
                  <div className={classes.priceTag}>Por apenas <span>{numberAsCurrency(currentCampaign?.ticket_price)}</span></div>
                </div>
                {
                  currentCampaign && currentCampaign.instant_prize_tickets > 0 && currentCampaign["open?"] &&
                  <div className={classes.instantBox}>
                    <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/mascot.png" />
                    <div className={classes.instantDescription}>{currentCampaign?.instant_prize_description}</div>
                    <div className={classes.instantHelper}>{instantPrizeHelperText(currentCampaign)}</div>
                    <div style={{clear: 'both'}}></div>
                  </div>
                }
                {
                  currentCampaign && currentCampaign["open?"] &&
                  <SelectionBox selectedTickets={selectedTickets} purchaseCallback={purchaseCallback} setSelectedTickets={safeSetSelectedTickets} campaign={currentCampaign} loading={purchaseLoading}/>
                }
                {
                  currentCampaign?.show_winners && (currentCampaign?.drawn_customer || currentCampaign?.drawn_to_entity) && <ShortWinner campaign={currentCampaign} />
                }
                {
                  currentCampaign && currentCampaign.instant_prize_tickets > 0 && <InstantWinners campaign={currentCampaign} />
                }
                {
                  currentCampaign && <SubcampaignsSection campaign={currentCampaign} />
                }
                <div className={classes.description}>
                  <button
                    type="button"
                    className={classes.descriptionHeader}
                    onClick={() => setDescriptionOpen(!descriptionOpen)}
                  >
                    <span>Descrição</span>
                    <KeyboardArrowDownIcon
                      className={`${classes.descriptionArrow} ${descriptionOpen ? classes.descriptionArrowOpen : ''}`}
                    />
                  </button>
                  <div className={`${classes.descriptionContent} ${!descriptionOpen ? classes.descriptionContentClosed : ''}`}>
                    {(() => {
                      // Lista completa em regulation_pdfs; regulation_pdf_url é o
                      // fallback pra payload antigo ainda em cache.
                      const pdfs = currentCampaign?.regulation_pdfs?.length
                        ? currentCampaign.regulation_pdfs
                        : (currentCampaign?.regulation_pdf_url ? [{ id: 0, url: currentCampaign.regulation_pdf_url }] : []);
                      return pdfs.map((pdf, index) => (
                        <a
                          key={pdf.id || index}
                          href={pdf.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={classes.regulationLink}
                        >
                          {pdfs.length > 1 && pdf.filename
                            ? `Baixar ${pdf.filename.replace(/\.pdf$/i, '')} (PDF)`
                            : 'Baixar regulamento (PDF)'}
                        </a>
                      ));
                    })()}
                    <div dangerouslySetInnerHTML={{ __html: currentCampaign?.description_body }}></div>
                  </div>
                </div>
              </>
            )}
            {!loading && currentCampaign == null && (
              <Typography variant="body1">
                Campanha inválida
                <br/><br/><br/><br/>
              </Typography>
            )}
          </div>
        </div>
      </ResponsiveContainer>
    </ThemeProvider>
  )
}